import DOMPurify from "dompurify";

export const sanitizeHtml = (body) => {
  if (body === "") return "";
  return DOMPurify.sanitize(body, {
    ADD_ATTR: ["target"],
  });
};
